import React, { useCallback, useMemo } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../map/utils/mapFunctions';
import { TreeView } from '../../../../common/components/layout';
import { PipelineCenterlineExact } from '../../../models/PipelineCenterline';

const PipelineCenterlineTreeView = ({ centerlines, setCenterlines, setCenteredGeometries }) => {
  const handleCenterlinesCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(centerlines || [], item.id));
    },
    [centerlines, setCenteredGeometries]
  );

  const handleCenterlinesVisibilityClick = useCallback(
    (item, isToggled) => {
      setCenterlines((oldCenterlines) => getEntitiesWithVisibility(oldCenterlines, item.id, isToggled));
    },
    [setCenterlines]
  );

  const centerlinesItemActions = useMemo(
    () => [
      { id: 'centerline-center', icons: { default: 'gps_fixed' }, onClick: handleCenterlinesCenterClick },
      {
        id: 'centerline-visibility',
        icons: { default: 'visibility', toggled: 'visibility_off' },
        onClick: handleCenterlinesVisibilityClick,
      },
    ],
    [handleCenterlinesCenterClick, handleCenterlinesVisibilityClick]
  );

  const centerlineItems = useMemo(
    () => [
      {
        id: 'root',
        label: `${i18n.t('mission.details.centerlines')}: ${centerlines && centerlines.length}`,
        actions: centerlinesItemActions,
        children: centerlines.map((centerline, index) => ({
          id: index,
          label: `${i18n.t('mission.details.pipelineCenterline')} #${index + 1}`,
          actions: centerlinesItemActions,
        })),
      },
    ],
    [centerlines, centerlinesItemActions]
  );

  return <TreeView id="centerlines" items={centerlineItems} />;
};

PipelineCenterlineTreeView.propTypes = {
  centerlines: PropTypes.arrayOf(PipelineCenterlineExact),
  setCenterlines: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
};

PipelineCenterlineTreeView.defaultProps = {
  centerlines: [],
};

export default PipelineCenterlineTreeView;
